<template>
	<div>
		<b-container>
			<b-row>
				<b-col>
					Fichiers
					<b-form-file
						v-model="files_files"
						multiple
						@input="input(files_files)"
						placeholder="Sélectionner un ou plusieurs fichiers"
					></b-form-file>
				</b-col>
				<b-col>
					Dossiers
					<b-form-file
						v-model="files_folder"
						directory
						no-traverse
						multiple
						@input="input(files_folder)"
						placeholder="Sélectionner un dossier"
					></b-form-file>
				</b-col>
			</b-row>
		</b-container>
		<br />
		<b-table
			v-show="files.length > 0"
			striped
			hover
			:items="files"
			:fields="fields">
			<template v-slot:cell(index)="data">
				<b-button v-on:click="del(data.index)"
					><i class="fas fa-trash-alt"></i
				></b-button>
			</template>
		</b-table>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";

	export default {
		name: "file_names_parameter",
		components: {
		},
		data() {
			return {
				files_folder: [],
				files_files: [],
				files: [],
				fields: [
					{
						key: "name",
						label: "Nom",
					},
					{
						key: "path",
						label: "Chemin",
					},
					{
						key: "size",
						label: "Taille",
					},
					{
						key: "type",
						label: "Type",
					},
					{
						key: "index",
						label: "",
					},
				]
			};
		},
		methods: {
			del(idx)
			{
				this.files.splice(idx, 1);
			},
			input(files)
			{
				for (var i = 0; i < files.length; i++)
				{
					this.files.push({
						path: files[i].$path,
						name: files[i].name,
						size: files[i].size,
						type: files[i].type,
					})
				}
				this.files_folder = [];
				this.files_files = [];

				console.log(this.files)
			},
			get_data()
			{
				console.log("get")
				return this.files;
			},
			load(data)
			{

			},
			save()
			{
				return this.files;
			},
		},
		mounted: async function () {

			var self = this;
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		height:60px;
	}
</style>